import { render, staticRenderFns } from "./reserve-filter-horizontal.vue?vue&type=template&id=f0bf3f48&scoped=true"
import script from "./reserve-filter-horizontal.vue?vue&type=script&lang=js"
export * from "./reserve-filter-horizontal.vue?vue&type=script&lang=js"
import style0 from "./reserve-filter-horizontal.vue?vue&type=style&index=0&id=f0bf3f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bf3f48",
  null
  
)

export default component.exports